import { api, tr } from './shared';

export function getIikoSections(lang) {
  return [
    {
      id: 'iiko-overview',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'iiko',
      navGroupOrder: 25,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'iiko — обзор', 'iiko — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Интеграция iiko работает на уровне организации. Management API — Bearer пользователя Loyalclub; кассовые методы — X-API-Key. Поддерживаются cashback, discount, stamp, subscription и certificate.',
            'The iiko integration is organization-scoped. Management API uses a Loyalclub user Bearer token; POS methods use X-API-Key. Supported flows: cashback, discount, stamp, subscription, certificate.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Base URL', 'Base URL'),
          items: [`${api.host}/iiko`],
        },
        {
          type: 'list',
          title: tr(lang, 'Авторизация', 'Authorization'),
          items: [
            tr(lang, 'Management: Authorization: Bearer <USER_TOKEN>', 'Management: Authorization: Bearer <USER_TOKEN>'),
            'POS: X-API-Key: iiko_<API_KEY>',
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Типичный кассовый сценарий', 'Typical POS flow'),
          items: [
            'POST /iiko/customer/info — найти гостя по номеру карты',
            'POST /iiko/order/calc — рассчитать скидку / оплату бонусами / начисление',
            'POST /iiko/order/apply — применить операцию (идемпотентно по order_id)',
            'POST /iiko/order/cancel — отменить apply при возврате чека',
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Правила кассы (актуально)', 'POS rules (current)'),
          items: [
            tr(lang, 'Номер карты: ведущие нули не важны — 925 и 000925 это одна карта', 'Card number: leading zeros do not matter — 925 and 000925 are the same card'),
            tr(lang, 'Срок действия проверяется только у сертификата; пустая дата и 00.00.0000 — бессрочно', 'Expiry is checked only for certificates; empty date and 00.00.0000 mean no expiry'),
            tr(lang, 'Лимит списания % и уровни задаются в карте Loyalclub, не в теле кассового запроса', 'Redeem % cap and tiers are set on the Loyalclub card, not in the POS request body'),
            tr(lang, 'Если в apply bonus_payment > 0, кэшбэк за этот чек не начисляется. Начисление — отдельным чеком без списания', 'If apply has bonus_payment > 0, this receipt does not accrue cashback. Accrue on a separate receipt with zero spend'),
            tr(lang, 'Сертификат: остаток списывается несколькими чеками, пока amount > 0; лимит чека = min(остаток, сумма чека)', 'Certificate: remainder can be spent across receipts while amount > 0; receipt cap = min(remainder, order sum)'),
            tr(lang, 'Процент начисления может быть выше в день рождения, если акция включена в карте', 'Accrual percent may be higher on the guest birthday if that campaign is enabled on the card'),
            tr(lang, 'waiter / cashier в apply опциональны. Ошибка атрибуции сотрудника не отменяет лояльность', 'waiter / cashier on apply are optional. Staff attribution errors do not fail loyalty'),
          ],
        },
      ],
    },
    {
      id: 'iiko-integration-create',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'iiko',
      navGroupOrder: 25,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: tr(lang, 'Создать интеграцию', 'Create integration'),
      title: 'POST /iiko/integration/organization/{org_id}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Создаёт интеграцию организации и возвращает api_key (показывается при создании/ротации). org_id — UUID организации Loyalclub.',
            'Creates an organization integration and returns api_key (shown on create/rotate). org_id is the Loyalclub organization UUID.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'list',
          title: tr(lang, 'Поля тела (все опциональны)', 'Body fields (all optional)'),
          items: ['restaurant_id', 'terminal_group_id', 'organization_iiko_id', 'settings'],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'iiko-create',
          value: `curl -X POST "${api.host}/iiko/integration/organization/<ORG_UUID>" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{"restaurant_id":"rest-1","terminal_group_id":"tg-1"}'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'iiko-create-resp',
          value: `{\n  "id": 3,\n  "organization_id": 42,\n  "api_key": "iiko_abc123...",\n  "is_active": true,\n  "restaurant_id": "rest-1",\n  "terminal_group_id": "tg-1"\n}`,
        },
      ],
    },
    {
      id: 'iiko-integration-get',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'iiko',
      navGroupOrder: 25,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 20,
      navLabel: tr(lang, 'Получить интеграцию', 'Get integration'),
      title: 'GET /iiko/integration/organization/{org_id}',
      blocks: [
        { type: 'text', value: tr(lang, 'Возвращает текущую интеграцию организации.', 'Returns the current organization integration.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'code',
          title: 'curl',
          key: 'iiko-get',
          value: `curl -X GET "${api.host}/iiko/integration/organization/<ORG_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'iiko-integration-update',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'iiko',
      navGroupOrder: 25,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 30,
      navLabel: tr(lang, 'Обновить / ключ / удалить', 'Update / key / delete'),
      title: 'PUT|POST regenerate|DELETE /iiko/integration/organization/{org_id}',
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Методы', 'Methods'),
          items: [
            'PUT /iiko/integration/organization/{org_id}',
            'POST /iiko/integration/organization/{org_id}/regenerate-key',
            'DELETE /iiko/integration/organization/{org_id}',
          ],
        },
        {
          type: 'code',
          title: 'curl regenerate-key',
          key: 'iiko-regen',
          value: `curl -X POST "${api.host}/iiko/integration/organization/<ORG_UUID>/regenerate-key" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'iiko-customer-info',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'iiko',
      navGroupOrder: 25,
      navSubgroup: tr(lang, 'Кассовый API', 'POS API'),
      navSubgroupOrder: 20,
      navOrder: 10,
      navLabel: 'POST /customer/info',
      title: 'POST /iiko/customer/info',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Ищет клиента по номеру карты в организации интеграции. Ведущие нули отбрасываются. Возвращает баланс, проценты, штампы и capabilities. Если карта не найдена или сертификат просрочен — success=false и поле error.',
            'Looks up a customer by card number within the integration organization. Leading zeros are ignored. Returns balance, percents, stamps and capabilities. If the card is missing or the certificate is expired — success=false and an error field.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['X-API-Key: iiko_<API_KEY>'] },
        {
          type: 'list',
          title: tr(lang, 'Поля запроса', 'Request fields'),
          items: ['card_number (string, обязательно)'],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'iiko-info',
          value: `curl -X POST "${api.host}/iiko/customer/info" \\\n  -H "Content-Type: application/json" \\\n  -H "X-API-Key: iiko_<API_KEY>" \\\n  -d '{"card_number":"925"}'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'iiko-info-resp',
          value: `{\n  "success": true,\n  "card_number": "000925",\n  "customer_id": "46",\n  "name": "Иван",\n  "phone": "+79990001122",\n  "balance": 1200,\n  "available_payment": 600,\n  "cashback_percent": 5,\n  "discount_percent": 0,\n  "card_type": "cashback",\n  "stamps": 0,\n  "stamps_to_reward": 0,\n  "available_rewards": 0,\n  "subscription_visits_left": 0,\n  "capabilities": {"card_type": "cashback", "can_discount": false, "can_spend": true, "can_accrue": true, "can_redeem_reward": false, "can_visit": false, "can_cancel": true}\n}`
        },
      ],
    },
    {
      id: 'iiko-customer-balance',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'iiko',
      navGroupOrder: 25,
      navSubgroup: tr(lang, 'Кассовый API', 'POS API'),
      navSubgroupOrder: 20,
      navOrder: 20,
      navLabel: 'POST /customer/balance',
      title: 'POST /iiko/customer/balance',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Короткий запрос баланса по номеру карты (тот же контракт ответа, что customer/info).',
            'Short balance lookup by card number (same response contract as customer/info).',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['X-API-Key: iiko_<API_KEY>'] },
        {
          type: 'code',
          title: 'curl',
          key: 'iiko-balance',
          value: `curl -X POST "${api.host}/iiko/customer/balance" \\\n  -H "Content-Type: application/json" \\\n  -H "X-API-Key: iiko_<API_KEY>" \\\n  -d '{"card_number":"000042"}'`,
        },
      ],
    },
    {
      id: 'iiko-order-calc',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'iiko',
      navGroupOrder: 25,
      navSubgroup: tr(lang, 'Кассовый API', 'POS API'),
      navSubgroupOrder: 20,
      navOrder: 30,
      navLabel: 'POST /order/calc',
      title: 'POST /iiko/order/calc',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Расчёт скидки, доступной оплаты бонусами и потенциального начисления по сумме чека. Баланс не меняется. calc показывает начисление до выбора суммы списания — даже если потом apply с bonus_payment > 0 начисление не сделает.',
            'Calculates discount, available bonus payment and potential accrual for the order sum. Balance is not changed. calc shows accrual before the cashier chooses spend — even if a later apply with bonus_payment > 0 will not accrue.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Поля запроса', 'Request fields'),
          items: [
            'card_number (string, обязательно)',
            'order_sum (number > 0, обязательно)',
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Поля ответа', 'Response fields'),
          items: [
            'discount_sum — скидка в рублях (тип discount)',
            'max_bonus_payment — максимум к списанию (кэшбэк с учётом лимита %; сертификат = min(остаток, order_sum))',
            'bonus_to_accrual — потенциальное начисление, если списания не будет',
            'discount_percent, balance, card_type, stamps, capabilities',
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'iiko-calc',
          value: `curl -X POST "${api.host}/iiko/order/calc" \\\n  -H "Content-Type: application/json" \\\n  -H "X-API-Key: iiko_<API_KEY>" \\\n  -d '{"card_number":"000925","order_sum":1500}'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'iiko-calc-resp',
          value: `{\n  "success": true,\n  "card_number": "000925",\n  "discount_sum": 0,\n  "bonus_payment_sum": 0,\n  "max_bonus_payment": 600,\n  "bonus_to_accrual": 75,\n  "discount_percent": 0,\n  "balance": 1200,\n  "card_type": "cashback",\n  "stamps": 0,\n  "capabilities": {"card_type": "cashback", "can_discount": false, "can_spend": true, "can_accrue": true, "can_redeem_reward": false, "can_visit": false, "can_cancel": true}\n}`
        },
      ],
    },
    {
      id: 'iiko-order-apply',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'iiko',
      navGroupOrder: 25,
      navSubgroup: tr(lang, 'Кассовый API', 'POS API'),
      navSubgroupOrder: 20,
      navOrder: 40,
      navLabel: 'POST /order/apply',
      title: 'POST /iiko/order/apply',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Применяет операцию лояльности к чеку. Идемпотентность по order_id: повтор с тем же order_id вернёт duplicate=true без второго списания.',
            'Applies the loyalty operation to the order. Idempotent by order_id: a repeat with the same order_id returns duplicate=true without a second debit.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Поля запроса', 'Request fields'),
          items: [
            'card_number (string, обязательно)',
            'order_sum (number > 0, обязательно)',
            'order_id (string, обязательно)',
            'bonus_payment (int >= 0, опционально)',
            'reward_redeem_count (int >= 0, опционально)',
            'terminal_id / cashier_id (опционально, legacy)',
            'waiter / cashier (опционально: {id, name, role})',
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Поля ответа', 'Response fields'),
          items: [
            'duplicate — повтор с тем же order_id, без второго списания',
            'bonus_used / bonus_accrued / reward_redeemed / discount_sum / new_balance',
            'operation — accrue | spend | spend_and_accrue | reward_redeem (зависит от типа карты и полей запроса)',
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Кэшбэк: если bonus_payment > 0, бонусы за этот чек не начисляются. Начисление только когда списание 0. Сертификат можно списывать повторно, пока остаток amount > 0.',
            'Cashback: if bonus_payment > 0, this receipt does not accrue. Accrual runs only when spend is 0. A certificate can be spent again while remainder amount > 0.',
          ),
        },
        {
          type: 'code',
          title: 'curl',
          key: 'iiko-apply',
          value: `curl -X POST "${api.host}/iiko/order/apply" \\\n  -H "Content-Type: application/json" \\\n  -H "X-API-Key: iiko_<API_KEY>" \\\n  -d '{\n    "card_number": "000925",\n    "order_sum": 1500,\n    "order_id": "CHK-1001",\n    "bonus_payment": 200,\n    "waiter": {"id": "w-guid", "name": "Иван", "role": "waiter"},\n    "cashier": {"id": "c-guid", "name": "Мария", "role": "cashier"}\n  }'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'iiko-apply-resp',
          value: `{\n  "success": true,\n  "duplicate": false,\n  "transaction_id": 881,\n  "card_number": "000925",\n  "order_id": "CHK-1001",\n  "bonus_used": 200,\n  "bonus_accrued": 0,\n  "reward_redeemed": 0,\n  "discount_sum": 0,\n  "new_balance": 1000,\n  "card_type": "cashback",\n  "operation": "spend"\n}`,
        },
      ],
    },
    {
      id: 'iiko-order-cancel',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'iiko',
      navGroupOrder: 25,
      navSubgroup: tr(lang, 'Кассовый API', 'POS API'),
      navSubgroupOrder: 20,
      navOrder: 50,
      navLabel: 'POST /order/cancel',
      title: 'POST /iiko/order/cancel',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Отменяет ранее применённый apply по order_id (возврат чека). Повторная отмена безопасна. card_number опционален: если его не передать, карта определяется по исходной операции заказа.',
            'Cancels a previously applied operation by order_id (order refund). Repeat cancel is safe. card_number is optional: when omitted, the card is resolved from the original apply for that order.',
          ),
        },
        {
          type: 'code',
          title: 'curl',
          key: 'iiko-cancel',
          value: `curl -X POST "${api.host}/iiko/order/cancel" \\\n  -H "Content-Type: application/json" \\\n  -H "X-API-Key: iiko_<API_KEY>" \\\n  -d '{"order_id":"CHK-1001","card_number":"000042"}'`,
        },
      ],
    },
  ];
}
